/* eslint-disable wrap-iife */
import "./print-brochure";
import "./contact-form-slide";
import "./view-all-destinations";
import "./camps-lodges";
import "./quick-links";
import "./show-hidden-text";
import "./view-gallery";
import "./best-time-to-go";
import "./faqs";
import "./our-favourite-camps";
import "./parks-areas";
import "./inspiring-itineraries";
import "./overview-accordions";
import "./travel-experts-top-safaris-slider";
import "./itinerary-block";
import "./explore";
import "./flyout-menu";
import "./read-more";
import "./popular-safaris";
import "./brochures";
import "./when-to-see-load-more";
import "./privacy-policy";
import "./itineraries-filter";
import "./top-safaris";
import "./video-modal";

(function($) {
  // Scroll to anchor
  $('a[href*="#"]').on("click", function(e) {
    $("html,body").animate(
      {
        scrollTop: $($(this).attr("href")).offset().top - 190
    }, 0
    );
    e.preventDefault();
  });
  //Announcement Banner
  $('.announcement-banner__close').on("click", function(e) {
    $('.announcement-banner').addClass('closed');
  })
  // Parallax Effect
  function isInViewport(node) {
    var rect = node.getBoundingClientRect();
    return (
      (rect.height > 0 || rect.width > 0) &&
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }


  // Slick sliders
  $(".featuredslider").slick({
    dots: true,
    customPaging: function(slider, i) {
      var thumb = $(slider.$slides[i]).data();
      return "<span>0" + (i + 1) + "</span>";
    }
  });
  $(".featuredslider").slick({
    dots: true,
    customPaging: function(slider, i) {
      var thumb = $(slider.$slides[i]).data();
      return "<span>0" + (i + 1) + "</span>";
    }
  });
  $(".featured-blog-slide").slick({
    dots: true,
    arrows: false,
    draggable: true,
    customPaging: function(slider, i) {
      var thumb = $(slider.$slides[i]).data();
      return "<span>0" + (i + 1) + "</span>";
    }
  });
  $(".videoslider").slick({
    centerMode: true,
    speed: 1200,
    centerPadding: "60px",
    slidesToShow: 1,
    arrows: true,
    draggable: true,
    dots: false,
    autoplay: false,
    autoplaySpeed: 5000,
    adaptiveHeight: false,
    variableWidth: true,
    waitForAnimate: true,
    useTransform: false,
    cssEase: "cubic-bezier(.55,.54,.55,.54)",
    // cssEase: "linear",
    infinite: true
  });
  $(".responsive_featurein").slick({
    centerMode: true,
    centerPadding: "60px",
    slidesToShow: 6,
    arrows: false,
    draggable: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: false,
    variableWidth: true,
    cssEase: "linear",
    infinite: true
  });
  if (window.matchMedia("(max-width: 608px)").matches) {
    /* the viewport is less than 768 pixels wide */
    $(".our-process-list").slick({
      centerMode: true,
      centerPadding: "40px",
      slidesToShow: 1,
      arrows: false,
      draggable: true,
      dots: false,
      autoplay: false,
      autoplaySpeed: 4000,
      adaptiveHeight: true,
      variableWidth: true,
      cssEase: "linear",
      infinite: true
    });
  }

  // load more post start
  jQuery(".load-more-cta-btn").click(function() {
    console.log(Date.now());
    var catid = $(this).data("catid");
    var count = $(this).data("count");
    var featured_slider_id = jQuery("#featured_slider_id").val();
    var offset = jQuery(".post_items").length; //check if we need to remove the sticky ones
    var data = {
      action: "show_next_posts",
      category: catid,
      offset: offset,
      featured_slider_id: featured_slider_id
    };

    var loadPost = jQuery.post(ajaxurl, data, function(response) {
      jQuery("#blog-container-add").append(response);
    });
    loadPost.done(function(data) {
      if (count && count <= jQuery(".post_items").length)
        $(".load-more-cta").fadeOut("slow");
      console.log("done");
    });
  });
  // end load more post start

  // $(window).scroll(function() {
  //   if ($(this).scrollTop() > 1000) {
  //     $("#scrolltotop").fadeIn();
  //   } else {
  //     $("#scrolltotop").fadeOut();
  //   }
  // });
  $("#scrolltotop").click(function() {
    $("html, body").animate({ scrollTop: 0 }, 800);
    return false;
  });

  //Custom select
  // Iterate over each select element

  $(".custom_select").each(function() {
    var $this = $(this),
      numberOfOptions = $(this).children("option").length;

    $this.addClass("select-hidden");
    $this.wrap('<div class="select"></div>');
    $this.after('<div class="select-styled"></div>');

    var $styledSelect = $this.next("div.select-styled");
    $styledSelect.text(
      $this
        .children("option")
        .eq(0)
        .text()
    );

    var $list = $("<ul />", {
      class: "select-options"
    }).insertAfter($styledSelect);

    for (var i = 0; i < numberOfOptions; i++) {
      $("<li />", {
        text: $this
          .children("option")
          .eq(i)
          .text(),
        rel: $this
          .children("option")
          .eq(i)
          .val()
      }).appendTo($list);
    }

    var $listItems = $list.children("li");

    $styledSelect.click(function(e) {
      console.log("$styledSelect");
      e.stopPropagation();
      $("div.select-styled.active")
        .not(this)
        .each(function() {
          $(this)
            .removeClass("active")
            .next("ul.select-options")
            .hide();
        });
      $(this)
        .toggleClass("active")
        .next("ul.select-options")
        .toggle();
    });

    $listItems.click(function(e) {
      e.stopPropagation();
      $styledSelect.text($(this).text()).removeClass("active");
      $this.val($(this).attr("rel"));
      $list.hide();
      console.log($this.val());
    });

    $(document).click(function() {
      $styledSelect.removeClass("active");
      $list.hide();
    });
  });
  //end custom select

  // end
})(jQuery);

$('#cookieBannerGotIt').on('click', function() {
  $('#cookieBanner').addClass('closed');
  setCookie("cookie-banner", 'closed', 30);
})

function setCookie(cname,cvalue,exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

$(window).scroll(function() {    
  var scroll = $(window).scrollTop();
  let header = document.getElementsByTagName('body');

  if (scroll > 1) {
    header[0].classList.add('mini');
  } else {
    header[0].classList.remove('mini');
  }
});